import actionMessagesReducer, {
} from '@redux/reducers/actionMessages.reducer';
import badgesReducer from '@redux/reducers/badges.reducer';
import localeReducer from '@redux/reducers/locale.reducer';
import organizationReducer from '@redux/reducers/organization.reducer';
import userReducer, { UserTypes } from '@redux/reducers/user.reducer';
import { combineReducers } from 'redux';
import impersonateReducer from './reducers/impersonate.reducer';
import wolfieReducer from './reducers/wolfie.reducer';

const appReducer = combineReducers({
  actionMessages: actionMessagesReducer,
  badges: badgesReducer,
  locale: localeReducer,
  user: userReducer,
  organization: organizationReducer,
  impersonate: impersonateReducer,
  wolfie: wolfieReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === UserTypes.LOGOUT_USER) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
